import { z } from 'zod';
import { idSchema } from './common.js';
export const licenseSchema = z.object({
    /** SPDX-Kennung oder Quellenbezeichnung. */
    spdx: z.string().min(1),
    author: z.string().optional(),
    sourceUrl: z.string().optional(),
    attributionRequired: z.boolean(),
    attributionText: z.string().optional(),
});
export const assetSchema = z
    .object({
    id: idSchema,
    kind: z.enum(['image', 'sound', 'font']),
    mime: z.string().min(3),
    /** SHA-256 der Datei, gleichzeitig Speicherort unter /assets/<hash>. */
    hash: z.string().regex(/^[0-9a-f]{64}$/, { error: 'hash muss ein SHA-256 in Hex sein' }),
    variants: z
        .object({
        color: idSchema.optional(),
        bw: idSchema.optional(),
        outline: idSchema.optional(),
    })
        .optional(),
    meta: z.object({
        name: z.string(),
        tags: z.array(z.string()).default([]),
        widthPx: z.number().int().positive().optional(),
        heightPx: z.number().int().positive().optional(),
        durationMs: z.number().int().positive().optional(),
    }),
    license: licenseSchema,
})
    .refine((asset) => asset.license.spdx !== 'own' || !!asset.license.author, {
    error: 'Eigene Assets brauchen eine Urheberangabe',
    path: ['license', 'author'],
});
//# sourceMappingURL=assets.js.map